export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/ACLU.1dd7b1fe.svg","height":101,"width":116,"blurWidth":0,"blurHeight":0};